import { render, staticRenderFns } from "./WorkOrderSummary.vue?vue&type=template&id=b28ce238&scoped=true"
import script from "./WorkOrderSummary.vue?vue&type=script&lang=js"
export * from "./WorkOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderSummary.vue?vue&type=style&index=0&id=b28ce238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28ce238",
  null
  
)

export default component.exports